import type { API } from 'chessboard/api/config/types';
import { Core } from 'chessboard/core/config/types';

/**
 * Create the selectNode method.
 */
export function createSelectNode(context: API.Context) {
  /**
   * Select a node by line and move.
   */
  return function selectNode(lineId: number, moveId: number): API.Response {
    const { api, game, respond } = context;
    const before = game.moveDetails();

    game.selectPosition(moveId, lineId);

    const after = game.moveDetails();
    const data = api.getNodeDiffData(before, after);

    if (data.plyDiff === 0 && data.lineDiff === 0) {
      return null;
    }

    if (data.lineDiff !== 0) {
      data.pieces = api.getPieces();
    }

    const response = respond(Core.APIEvents.SelectNode, data);

    return response;
  };
}
